import { defineComponent as y, mergeModels as V, useModel as O, computed as n, openBlock as h, createElementBlock as C, createVNode as f, unref as c, mergeProps as i, withCtx as d, renderSlot as v, createElementVNode as D, toDisplayString as M } from "vue";
import Y from "dayjs";
/* empty css                      */
import "../CalendarGrid/v-calendar-grid.vue.js";
/* empty css                                   */
import "@vueuse/core";
/* empty css                          */
import g from "../DateSelect/v-date-select.vue.js";
/* empty css                               */
import { useMaxDate as w, useMinDate as x } from "../CalendarGrid/composables/date.js";
/* empty css                  */
/* empty css                  */
/* empty css                                 */
/* empty css                                           */
/* empty css                                                   */
/* empty css                                    */
/* empty css                                  */
/* empty css                                    */
/* empty css                                   */
/* empty css                               */
/* empty css                                                 */
/* empty css                                              */
const B = { class: "v-date-range" }, T = /* @__PURE__ */ y({
  __name: "v-date-range",
  props: /* @__PURE__ */ V({
    dateFormat: { default: () => ({
      default: "YYYY. MM. DD.",
      sameMonth: ["YYYY. MMM. D.", "D."],
      sameYear: ["YYYY. MM. D.", "MMM. D."]
    }) },
    minDate: {},
    maxDate: {},
    maxInterval: {},
    classes: { type: Function, default: () => ({}) },
    disallow: {},
    name: {},
    color: { default: "primary" },
    navColor: {},
    mode: {}
  }, {
    modelValue: {
      default: () => [Y().startOf("day"), Y().endOf("day")]
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(u) {
    const l = u, o = O(u, "modelValue"), r = n({
      get: () => o.value[0],
      set: (t) => {
        o.value = [t, w(t.endOf("day"), o.value[1])];
      }
    }), s = n({
      get: () => o.value[1],
      set: (t) => {
        o.value = [x(t.startOf("day"), o.value[0]), t];
      }
    }), p = n(() => ({
      disallowClear: !0,
      disallow: l.disallow,
      minDate: l.minDate,
      maxDate: l.maxDate,
      navColor: l.navColor,
      color: l.color
    }));
    return (t, m) => (h(), C("div", B, [
      f(c(g), i({
        modelValue: r.value,
        "onUpdate:modelValue": m[0] || (m[0] = (e) => r.value = e)
      }, p.value, {
        classes: (e) => t.classes(e, "start")
      }), {
        title: d(() => [
          v(t.$slots, "title-1")
        ]),
        day: d(({ btnProps: e, value: a }) => [
          D("button", i(e, {
            class: {
              highlight: a.valueOf() !== r.value.valueOf() && a.isAfter(r.value) && a.isBefore(s.value)
            }
          }), M(a.date()), 17)
        ]),
        _: 3
      }, 16, ["modelValue", "classes"]),
      f(c(g), i({
        modelValue: s.value,
        "onUpdate:modelValue": m[1] || (m[1] = (e) => s.value = e)
      }, p.value, {
        normalize: (e) => e.endOf("day"),
        classes: (e) => t.classes(e, "end")
      }), {
        title: d(() => [
          v(t.$slots, "title-2")
        ]),
        day: d(({ btnProps: e, value: a }) => [
          D("button", i(e, {
            class: {
              highlight: a.valueOf() !== s.value.valueOf() && a.isAfter(r.value) && a.isBefore(s.value)
            }
          }), M(a.date()), 17)
        ]),
        _: 3
      }, 16, ["modelValue", "normalize", "classes"])
    ]));
  }
});
export {
  T as default
};
